import $ from 'jquery';
import 'slick-carousel';

export default function() {
  const $productSlider = $('[data-ps]');

  if ($productSlider.length) {
    $productSlider.on('init', function() {
      $productSlider.addClass('is-visible');
    })

    const sliderConfig = {
      asNavFor: '.product-thumb-slider',
      focusOnSelect: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="18.535" height="35" viewBox="0 0 18.535 35"><path d="M47.289 32.074L31.544 16.339A1.033 1.033 0 0 1 33 14.878l16.469 16.465a1.03 1.03 0 0 1 0 1.463L33 49.271a1.033 1.033 0 1 1-1.461-1.461z" transform="translate(-31.239 -14.576)"/></svg></button>',
      prevArrow: '<button class="slick-prev"><svg style="transform: rotateY(180deg);" xmlns="http://www.w3.org/2000/svg" width="18.535" height="35" viewBox="0 0 18.535 35"><path d="M47.289 32.074L31.544 16.339A1.033 1.033 0 0 1 33 14.878l16.469 16.465a1.03 1.03 0 0 1 0 1.463L33 49.271a1.033 1.033 0 1 1-1.461-1.461z" transform="translate(-31.239 -14.576)"/></svg></button>',
      dots: false,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            arrows: false,
            infinite: true
          }
        }
      ]
    };

    if( $productSlider.parents('.productTemplate--b').length != 0 && $productSlider.parents('.productTemplate--newBundle').length == 0 ){
      delete sliderConfig.asNavFor;
      sliderConfig.dots = false;
      sliderConfig.adaptiveHeight = true;
      sliderConfig.responsive.dots = false;
      // sliderConfig.slide = 'a[data-contains]';
    }

    if($productSlider.parents('.productTemplate--newBundle').length != 0 ){
      sliderConfig.responsive[0].settings.infinite = false;
    }

    const slider = $productSlider.slick(sliderConfig).on('afterChange', function(slick, currentSlide, nextSlide){
      $(".custom-slider-dots ul li").removeClass('active');
      $(".custom-slider-dots ul li").eq(nextSlide % 4).addClass('active');
    });

    $(".custom-slider-dots ul li").on('click', function(){
      var idx = $(this).index();

      $productSlider.slick('slickGoTo', idx);
    })
    function getLifeStyleSlide(){
      var ls_index = 100;
      $('[data-ps] .slick-slide').each(function (index) {
        if ($(this).find('img.lifestyle').length > 0 ) {
          ls_index = index;
        }
       });
      return ls_index;
    }

    function getLifeStyleSlideThumb(){
      var ls_index = 100;
      $('[data-thumb-ps] .slick-slide:not(.slick-cloned)').each(function (index) {
        if ($(this).find('img.lifestyle').length > 0 ) {
          ls_index = index;
        }
       });
      return ls_index;
    }
    function reindex(slider) {
      var indx = 0;
      $.each($(slider + " .slick-slide:not(.slick-cloned)"), function (t, v) {
          $(v).attr("data-slick-index", indx);
          indx++;
      });
    }

    if (screen.width >= 990) {
      var toRemove = parseInt(getLifeStyleSlide());

      if (toRemove < 100) {
        $productSlider.slick('slickRemove', toRemove);
        reindex('[data-ps]');
      }
    }

    const $productThumbSlider = $('[data-thumb-ps]');
    if($productThumbSlider.length) {
      $productThumbSlider.on('init', function(){
        $productThumbSlider.addClass('is-visible');
      })
      const thumbSlider = $productThumbSlider.slick({
        asNavFor: '.product-slider',
        slidesToShow: 3.8,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        focusOnSelect: true
      });

      if (screen.width >= 990) {
        const toRemove = parseInt(getLifeStyleSlideThumb());

        if (toRemove < 100) {
          $productThumbSlider.slick('slickRemove', toRemove);
          reindex('[data-thumb-ps]');
        }
      }
    }
    
  }
}